import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import styled from 'styled-components';

import largeSuccess from '../../svg/large-success.svg';

const Title = styled.div`
  font-size: 22px;
  font-family: BrandonGrotesque-Medium;
  width: 200px;
  margin: auto;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
  color: var(--color-gunmetal);
`;

const Contact = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 16px;
  letter-spacing: 0.7px;
  margin: 30px auto 0;
  width: 200px;
  text-align: center;
  color: var(--color-cool-grey);
`;

const OkayButton = styled.button`
  border: 0;
  display: block;
  margin: 30px auto 0;
  background-color: var(--color-gunmetal);
  font-family: BrandonGrotesque-Regular;
  font-size: 18px;
  letter-spacing: 1px;
  color: #ffffff;
  cursor: pointer;
  padding: 10px 20px;
`;

const Icon = styled.img`
  margin: 30px auto;
  display: block;
`;

class MethodAdded extends React.Component<{ redirect: Function; desktop?: boolean }> {
  render() {
    const desktopStyle = {
      backgroundColor: 'white',
      position: 'absolute' as const,
      width: '500px',
    };

    return (
      <div style={this.props.desktop ? desktopStyle : {}}>
        <Icon src={largeSuccess} alt="Success" />
        <Title>Payment method added successfully!</Title>
        <Contact>
          Please contact <br />
          <a
            href="mailto:partnerships@neoncoat.com"
            style={{ color: 'var(--color-cool-grey)', textDecoration: 'underline' }}
          >
            partnerships@neoncoat.com
          </a>{' '}
          <br />
          with any questions.
        </Contact>
        <OkayButton onClick={() => this.props.redirect()}>Okay</OkayButton>
      </div>
    );
  }
}

const mapDispatchToProps = {
  redirect: () => push('/billing/methods'),
};

export default connect(null, mapDispatchToProps)(MethodAdded);
